(() => {
  const hero = document.querySelector('.pp-hero');
  const sticky = document.querySelector('.pp-sticky');
  if (hero && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const shown = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', shown);
      sticky.inert = !shown;
      sticky.setAttribute('aria-hidden', String(!shown));
    }).observe(hero);
  }
  const slides = [...document.querySelectorAll('.pp-slide')];
  const dots = [...document.querySelectorAll('.pp-dots button')];
  let current = 0;
  function show(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', String(i !== current));});
    dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
  }
  document.querySelector('.pp-carousel-arrow.prev')?.addEventListener('click', () => show(current - 1));
  document.querySelector('.pp-carousel-arrow.next')?.addEventListener('click', () => show(current + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
  document.querySelectorAll('input[name="pp-package"]').forEach(input => input.addEventListener('change', () => {
    const link = document.querySelector('#pp-product-link');
    if (link) link.href = input.dataset.url;
  }));
})();
